<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" ref="table" isAddPageToRouter
      :isOutside="isOutside" layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20, 50, 200]">
      <wt-table :labels="tableLabels" ref="tables" :list="tableData" @select="select" :isSelect="isShowSelect" @select-all="selectAll">
          <slot/>
      </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-points-reward-table'

export default {
  name: 'pt-points-reward-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    isShowSelect: {
      type: Boolean,
      default: false
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    clearSelection () {
      this.$refs.tables.clearSelection()
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next, size) {
      this.$emit('getTableData', page, next, size)
    },
    select (row) {
      this.$emit('select', row)
    },
    selectAll (rows) {
      this.$emit('selectAll', rows)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
